"use strict";

/**
 * This module defines a function that is similar to dojo/promises/all.  The important differences are:
 *
 * <ol>
 *     <li>It accepts an array of functions that return promises rather than an array of promises</li>
 *     <li>After calling each function it waits for the, potentially deferred, result before calling the next
 *     <li>It stops running through the array as soon as it encounters a disapproval</li>
 * </ol>
 *
 * @module mw-utils/allApprove
 * @copyright Copyright 2016 The MathWorks, Inc.
 */
define(["dojo/Deferred"], function (Deferred) {

    return function allApprove(approvers) {
        var deferred = new Deferred();
        var index = 0;
        var approveNext = function approveNext() {
            if (index === approvers.length) {
                deferred.resolve();
            } else {
                var approval = approvers[index++]();
                if (approval && typeof approval.then === "function") {
                    approval.then(function () {
                        approveNext();
                    }, function () {
                        deferred.reject();
                    });
                } else if (approval) {
                    approveNext();
                } else {
                    deferred.reject();
                }
            }
        };
        approveNext();
        return deferred.promise;
    };
});

